import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { accountingApi } from '../../services/accountingApi';
import AccountingFilters from '../../components/accounting/AccountingFilters';
import AccountingKpis from '../../components/accounting/AccountingKpis';
import AccountingCharts from '../../components/accounting/AccountingCharts';
import '../../styles/accounting.css';

export default function AccountingDashboard() {
    const [meta, setMeta] = useState({});
    const [data, setData] = useState({});
    const [filters, setFilters] = useState({
        from: '2026-07-03',
        to: new Date().toISOString().slice(0, 10),
    });

    const load = async () => {
        setMeta(await accountingApi.meta());
        setData(await accountingApi.dashboard(filters));
    };

    const search = async () => {
        setData(await accountingApi.dashboard(filters));
    };

    useEffect(() => {
        load();
    }, []);

    return (
        <div>
            <Header namePage="accountingDashboardPage" />

            <section className="sectionBody sectionBodyAccounting">
                <div className="containerCustom containerBody">
                    <main className="accountingPage">
                        <header className="accHero">
                            <div>
                                <span>Dashboard</span>
                                <h1>KPIs contables por sede, ciudad y área</h1>
                                <p>
                                    Filtros combinados para analizar gastos, ingresos, cajas, RUC,
                                    sedes, áreas, categorías y solicitantes.
                                </p>
                            </div>
                        </header>

                        <AccountingFilters
                            meta={meta}
                            filters={filters}
                            setFilters={setFilters}
                            onSearch={search}
                        />

                        <AccountingKpis summary={data.summary} />

                        <AccountingCharts data={data} />
                    </main>
                </div>
            </section>

            <Footer />
        </div>
    );
}
